import { bind } from "lodash-es";
import moment from "moment";
import { createRef, Component } from "react";
import { connect } from "react-redux";

import { showExportDialog } from "merchant/features/downloads/exportDialog/exportDialog";

import { nextTick } from "common/utils";
import { Tooltip } from "common/components/tooltip";

import { WebixDatatable } from "common/components/webix/react/Datatable";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowToBottom } from "@fortawesome/pro-regular-svg-icons";

import "./merchants.scss";

const mapStateToProps = (state) => ({
    merchants: state.common.all_merchants
});

const mapDispatchToProps = {};

export const MerchantsView = connect(mapStateToProps, mapDispatchToProps)(class extends Component {
    constructor(props) {
        super(props);
    
        this.tableRef = createRef();
    }
    
    exportMerchants = (e) => {
        e.preventDefault();
    
        const exportOptions = {
            dialogTitle: "Export merchants",
            filename: "merchants",
            filters: {},
            resources: [{
                value: "html",
                label: "HTML"
            }],
            activeResource: "html",
            content: [
                {
                    selected: true,
                    value: "",
                    label: "",
                    structure: null
                }
            ],
            formats: ["xlsx", "csv"],
            activeFormat: "xlsx",
            exporter: bind((payload) => {
                if (payload.content_type === "xlsx") {
                    this.tableRef.current.toExcel({
                        filename: payload.name
                    });
                } else if (payload.content_type === "csv") {
                    this.tableRef.current.toCSV({
                        filename: payload.name
                    });
                }
            }, this)
        };
        
        showExportDialog(exportOptions);
    };
    
    render() {
        const ui = {
            height: 800,
            columns: [
                {
                    id: "open",
                    header: "",
                    width: 38,
                    css: "details-link",
                    template: (item) => "<span class='tooltipped tooltipped-ne' aria-label='Navigate to the merchant'><i class='far fa-external-link-alt open-details'></i></span>"
                },
                {
                    header: "Name",
                    id: "display_name",
                    sort: "string",
                    fillspace: true,
                    minWidth: 200
                }, {
                    header: "ID",
                    id: "id",
                    adjust: true
                }, {
                    header: [{
                        content: "pazienSelectFilter",
                        onChange(master, arg1, arg2) {
                            master.filterByAll();
                        },
                        inputConfig: {
                            label: "Processors"
                        },
                        
                        separator: ",",
                        
                        suggest: {
                            fitMaster: false,
                            selectAll: true,
                            sortOptions: true,
                            width: 300
                        }
                    }],
                    adjust: true,
                    id: "processors",
                    template(obj, common, value) {
                        return value.join(", ");
                    }
                }, {
                    header: [{
                        content: "pazienSelectFilter",
                        onChange(master, arg1, arg2) {
                            master.filterByAll();
                        },
                        inputConfig: {
                            label: "Package"
                        },
                        suggest: {
                            fitMaster: false,
                            selectAll: true,
                            sortOptions: true,
                            width: 300
                        }
                    }],
                    width: 150,
                    id: "package_name"
                }, {
                    header: "Days left in trial",
                    adjust: true,
                    sort: "string",
                    id: "trial_end_date",
                    template(obj, common, value) {
                        if (!value) return "--";
                        
                        const trialEndDateMoment = moment.utc(value);
                        const trial = {
                            days_remaining: Math.max(0, trialEndDateMoment.diff(moment.utc().subtract(1, "days"), "days")),
                            expire_date: trialEndDateMoment.subtract(1, "days").format("MMM D, YYYY")
                        };
                        
                        return trial.days_remaining;
                    }
                }
            ],
            on: {
                onItemClick({ row, column }, e, obj) {
                    nextTick(() => {
                        if (column === "open") {
                            const { id } = this.getItem(row);
                            window.open(`/merchant/dashboard?merchant=${id}`);
                        }
                    });
                    
                    return false;
                },
    
                onCollectValues(id, data) {
                    data.values = Array.from(data.values.reduce((memo, { value }) => {
                        if (Array.isArray(value)) {
                            value.forEach((v) => memo.add(v));
                        } else {
                            memo.add(value);
                        }
                        return memo;
                    }, new Set())).map((v) => ({ id: v, value: v }));
                }
            }
        };
    
        return (
            <div className="merchants-body">
                <div className="table-actions btn-group">
                    <Tooltip title="Export results">
                        <span className="action btn btn-default" onClick={this.exportMerchants}>
                            <FontAwesomeIcon className="download-icon" icon={faArrowToBottom}/>
                        </span>
                    </Tooltip>
                </div>
                
                <WebixDatatable
                    ref={this.tableRef}
                    className="report-grid"
                    ui={ui}
                    data={this.props.merchants}
                />
            </div>
        );
    }
});
